<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>My Child</h1>
            <ul>
                <li>
                    <a [routerLink]="['/freemock']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i>
                        Back</a>
                </li>
            </ul>
        </div>
    </div>
</div>

<!-- <div class="el-breadcrumb-wrapper">
        <div class="container">
            <div class="el-breadcrmb-inner">
                <h1>My Child</h1>

            </div>
        </div>
    </div> -->



<div class="el-work-wrapper el-object-wrapper" *ngIf="!isAddChild">
    <div class="container">
        <div class="el-work-heading text-center">
            <h4 class="el-top-heading-center">Child Details</h4>
        </div>
        <div class="row gy-4">

            <div class="col-lg-4 col-md-6" *ngFor="let child of ChildList">
                <div class="el-work-box el-work-box-1">
                    <div class="el-work-box-inner">
                        <div class="el-work-img">
                            <img [src]="child.Photo" alt="work icon">

                        </div>
                        <div class="el-work-content">


                            <div class="text-start">
                                <ul>
                                    <li><i class="fa fa-user"></i>Child Name: <strong>{{child.childName}}</strong></li>
                                    <li><i class="fa fa-graduation-cap"></i>Class <strong>{{child.ClassId}}</strong>
                                    </li>
                                    <!-- <li><i class="fa fa-male"></i> {{child.Gender}}</li> -->
                                    <li></li>
                                </ul>
                            </div>

                            <div class="col-lg-12 d-flex justify-content-between">

                                <a class="el-btn my-2" (click)="Edit(child.StudentId)"> Edit</a>
                                <a class="el-btn my-2" [ngClass]="{'active-btn': child.ActiveStudent == 1}"
                                    *ngIf="child.ActiveStudent==1">Active Child</a>

                                <a class="el-btn my-2" *ngIf="child.ActiveStudent==null"
                                    (click)="Switch(child.StudentId)">Switch Account</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6" *ngIf="ChildList.length<5" (click)="isAddChild = !isAddChild;isEdit = false">
                <div class="el-work-box el-work-box-2">
                    <div class="el-work-box-inner">
                        <div class="el-work-img">
                            <i class="fa fa-plus fa-3x"></i>
                        </div>
                        <div class="el-work-content">
                            <h4>Add Child</h4>
                            <a class="el-btn my-2">Add</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="el-contact-page-wrapper" *ngIf="isAddChild">
    <div class="container">
        <div class="el-contact-page-box p-4">
            <div class="el-contact-page-info">
                <div class="el-team-heading el-contact-page-head">
                    <h2 class="el-main-heading">Add Child</h2>
                </div>
                <form [formGroup]="object" (ngSubmit)="saveChildRecord()">
                    <div class="ro d-flex justify-content-evenly">
                        <div class="col-lg-3">
                            <div class="el-input-field text-center" [hidden]="capturedImage!=null">
                                <div [hidden]="isShowCamera==false">
                                    <div id="camera-container">
                                        <video id="CameraId" #CameraId autoplay style="width:320px;">
                                        </video>
                                        <div id="frame" #frame width="150" height="180"></div>
                                    </div>
                                    <canvas #canvas width="150" height="180"
                                        style="border: 1px solid red; display: none;"></canvas>
                                    <br>
                                    <div class="row">
                                        <div class="col-lg-12 d-flex justify-content-between">
                                            <button type="button" class="el-btn py-4"
                                                (click)="captureImage()">Capture</button>
                                            <button type="button" class="el-btn py-4"
                                                (click)="ngOnDestroy()">Cancel</button>
                                        </div>
                                    </div>

                                    <p style="color: red;">{{msg}}</p>
                                </div>

                                <img *ngIf="object.get('photo')?.value && !isShowCamera"
                                    [src]="object.get('photo')?.value" width="300" height="300" alt="Preview">

                                <!-- <img *ngIf="previewUrl" [src]="previewUrl" alt="image" class="img-fluid"> -->

                                <img *ngIf="!isShowCamera && isEdit ==false"
                                    src="/assets/images/all-instructor/StudentImage.png" alt="image" class="img-fluid">

                                <button type="button" *ngIf="!isShowCamera" class="el-btn" (click)="openCamera()"
                                    style="margin-top: 10px;">Take live photo</button>
                                <small class="text-danger"
                                    *ngIf="object.get('photo')?.touched && object.get('photo')?.invalid">
                                    Photo is required
                                </small>
                            </div>
                            <div *ngIf="capturedImage!=null" class="text-center">
                                <img height="300px" [src]="capturedImage" alt="Captured" class="thumbnail" />
                                <button type="button" class="el-btn" (click)="openCamera()"
                                    style="margin-top: 10px;">Retake Live Photo</button>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="el-input-field">
                                <input type="text" placeholder=" Name" formControlName="childName">
                                <small class="text-danger"
                                    *ngIf="object.get('childName')?.touched && object.get('childName')?.hasError('required')">
                                    Name is required
                                </small>
                                <small class="text-danger"
                                    *ngIf="object.get('childName')?.touched && object.get('childName')?.hasError('minlength')">
                                    Name must be at least 2 characters
                                </small>
                            </div>
                            <!-- <div class="el-input-field">
                                <select class="form-control ng-pristine ng-valid ng-touched"
                                    style="height: 50px; background-color: transparent; border: 1px solid #e04787;"
                                    formControlName="gender">
                                    <option [ngValue]="null" disabled selected>--Select Gender--</option>
                                    <option [ngValue]="'Male'">Male</option>
                                    <option [ngValue]="'Female'">Female</option>
                                    <option [ngValue]="'Other'">Other</option>
                                </select>
                                <small class="text-danger"
                                    *ngIf="object.get('gender')?.touched && object.get('gender')?.invalid">
                                    Gender is required
                                </small>
                            </div> -->
                            <div class="el-input-field">
                                <select class="form-control ng-pristine ng-valid ng-touched"
                                    style="height: 50px; background-color: transparent; border: 1px solid #e04787;"
                                    formControlName="classId">
                                    <option [ngValue]="null" disabled selected>--Select Class--</option>
                                    <option [ngValue]="1">Class 1</option>
                                    <option [ngValue]="2">Class 2</option>
                                    <option [ngValue]="3">Class 3</option>
                                    <option [ngValue]="4">Class 4</option>
                                    <option [ngValue]="5">Class 5</option>
                                    <option [ngValue]="6">Class 6</option>
                                    <option [ngValue]="7">Class 7</option>
                                    <option [ngValue]="8">Class 8</option>
                                    <option [ngValue]="9">Class 9</option>
                                    <option [ngValue]="10">Class 10</option>
                                    <option [ngValue]="11">Class 11</option>
                                    <option [ngValue]="12">Class 12</option>
                                </select>
                                <small class="text-danger"
                                    *ngIf="object.get('classId')?.touched && object.get('classId')?.invalid">
                                    Class is required
                                </small>
                            </div>

                            <div class="col-lg-12 d-flex justify-content-between">
                                <button type="button" (click)="isAddChild=false ; object.reset();capturedImage = null;"
                                    class="el-btn">Back</button>

                                <button type="submit" class="el-btn"> {{ object.get('id')?.value > 0 ? 'Update' : 'Add'
                                    }}</button>



                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>